import {
  alphanumericMessage,
  maxLengthMessage,
  requiredMessage,
} from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 100;

export const carModelValidator = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(/^[a-z0-9 \-]+$/i, {
    message: alphanumericMessage,
    excludeEmptyString: true,
  });
export const carModelValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage)
  .matches(/^[a-z0-9 \-]+$/i, alphanumericMessage);
